var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 72,
    viewBox: "0 0 108 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.306875 36.096C0.306875 25.024 2.16288 16.384 5.87488 10.176C9.65088 3.904 16.1149 0.767996 25.2669 0.767996C34.4189 0.767996 40.8509 3.904 44.5629 10.176C48.3389 16.384 50.2269 25.024 50.2269 36.096C50.2269 47.296 48.3389 56.064 44.5629 62.4C40.8509 68.672 34.4189 71.808 25.2669 71.808C16.1149 71.808 9.65088 68.672 5.87488 62.4C2.16288 56.064 0.306875 47.296 0.306875 36.096ZM39.4749 36.096C39.4749 30.912 39.1229 26.528 38.4189 22.944C37.7789 19.36 36.4349 16.448 34.3869 14.208C32.3389 11.904 29.2989 10.752 25.2669 10.752C21.2349 10.752 18.1949 11.904 16.1469 14.208C14.0989 16.448 12.7229 19.36 12.0189 22.944C11.3789 26.528 11.0589 30.912 11.0589 36.096C11.0589 41.472 11.3789 45.984 12.0189 49.632C12.6589 53.28 14.0029 56.224 16.0509 58.464C18.1629 60.704 21.2349 61.824 25.2669 61.824C29.2989 61.824 32.3389 60.704 34.3869 58.464C36.4989 56.224 37.8749 53.28 38.5149 49.632C39.1549 45.984 39.4749 41.472 39.4749 36.096ZM67.8549 57.12C73.9989 51.808 78.8309 47.456 82.3509 44.064C85.9349 40.608 88.9109 37.024 91.2789 33.312C93.6469 29.6 94.8309 25.888 94.8309 22.176C94.8309 18.336 93.9029 15.328 92.0469 13.152C90.2549 10.976 87.4069 9.888 83.5029 9.888C79.7269 9.888 76.7829 11.104 74.6709 13.536C72.6229 15.904 71.5349 19.104 71.4069 23.136H60.8469C61.0389 15.84 63.2149 10.272 67.3749 6.432C71.5989 2.528 76.9429 0.575998 83.4069 0.575998C90.3829 0.575998 95.8229 2.496 99.7269 6.336C103.695 10.176 105.679 15.296 105.679 21.696C105.679 26.304 104.495 30.752 102.127 35.04C99.8229 39.264 97.0389 43.072 93.7749 46.464C90.5749 49.792 86.4789 53.664 81.4869 58.08L77.1669 61.92H107.599V71.04H60.9429V63.072L67.8549 57.12Z",
    fill: "url(#paint0_linear_1074_707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_707",
    x1: -9,
    y1: 77,
    x2: 71.647,
    y2: 33.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.516ec3775ec7db6a14a7c1be665eaeca.svg";
export { ForwardRef as ReactComponent };